import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { prepareApiHeaders } from "./prepareHeaders";

// manually added type from https://redux-toolkit.js.org/rtk-query/api/created-api/hooks#usequery
// since it was not easily derivable from package, replace if we find a way to do it
export type UseQueryResult<T> = {
  originalArgs?: unknown;
  data?: T;
  currentData?: T;
  error?: unknown;
  requestId?: string;
  endpointName?: string;
  startedTimeStamp?: number;
  fulfilledTimeStamp?: number;

  isUninitialized: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;

  refetch: () => void;
};

const baseUrl = import.meta.env.VITE_API_URL;

const tagTypes = [
  "Task",
  "PaymentMethod",
  "LinkToken",
  "Opportunity",
  "Policy",
  "AccountInfo",
  "PurchaseSchedule",
  "UserNotification",
  "ReferralStats",
  "ReferralAgreement",
  "OnboardingSession",
  "OnboardingSessionFiles",
  "Mfa",
] as const;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => prepareApiHeaders(headers),
  }),
  tagTypes,
  endpoints: () => ({}),
});
